import type { ElementAnimationConfig } from '@/js/modules/animate/types';
import {
  DATA_ANIMATE,
  DATA_DELAY,
  DATA_DURATION,
  DATA_EASE,
  DEFAULT_DELAY,
  DEFAULT_DURATION,
  isAnimationName,
} from '@/js/modules/animate/types';

function parsePositiveNumber(value: string | null, fallback: number): number {
  if (value === null || value.trim() === '')
    return fallback;

  const parsed = Number(value);

  if (!Number.isFinite(parsed) || parsed < 0)
    return fallback;

  return parsed;
}

function parseAnimationNames(raw: string): ElementAnimationConfig['names'] {
  const names = raw.split(/\s+/).map(part => part.trim()).filter(Boolean);
  const valid = names.filter(isAnimationName);

  return valid.length === names.length ? valid : [];
}

export function parseElementConfig(element: HTMLElement): ElementAnimationConfig | null {
  const rawName = element.getAttribute(DATA_ANIMATE)?.trim() ?? '';
  const names = parseAnimationNames(rawName);

  if (names.length === 0)
    return null;

  const easeRaw = element.getAttribute(DATA_EASE);
  const ease = easeRaw === null || easeRaw.trim() === '' ? null : easeRaw.trim();

  return {
    names,
    duration: parsePositiveNumber(element.getAttribute(DATA_DURATION), DEFAULT_DURATION),
    delay: parsePositiveNumber(element.getAttribute(DATA_DELAY), DEFAULT_DELAY),
    ease,
  };
}
